import React, { FC } from 'react';
import BottomScrollListener from 'react-bottom-scroll-listener';

import DatesSelector from 'components/Form/WeekRangePicker';
import ReportsTable from 'components/ReportsTable';
import { P } from 'components/Typography';
import useConnect from './connect';

import {
  Container,
  Grid,
  Types,
  ReportType,
  Section,
  Title,
  Card,
  ListWrapper,
  IconWrapper,
  CheckIcon,
  Button,
  LoaderWrapper,
  Spinner,
} from './styles';

const Download: FC = () => {
  const {
    hoverRange,
    selectedDays,
    handleDayChange,
    handleDayEnter,
    handleDayLeave,
    handleWeekClick,
    fromLimit,
    toLimit,

    reportType,
    setReportType,
    handleRequestReport,
    isRequestReportLoading,

    reports,
    isFetchingNextPage,
    isFetching,
    hasNextPage,
    fetchNextPage,
  } = useConnect();

  return (
    <Container>
      <Grid>
        <Section>
          <Title>Choose Report Type</Title>
          <Types>
            <ReportType
              type="button"
              variant="floating"
              color="secondary"
              className={reportType === 'DEPOSIT_REPORT' ? 'selected' : ''}
              onClick={() => {
                setReportType('DEPOSIT_REPORT');
              }}
            >
              Deposits
            </ReportType>
            {/* <ReportType
              type="button"
              variant="floating"
              color="secondary"
              className={reportType === 'ORDERS_REPORT' ? 'selected' : ''}
              onClick={() => {
                setReportType('ORDERS_REPORT');
              }}
            >
              Deposits
            </ReportType> */}
          </Types>
        </Section>
        <Section>
          <Title>Select Date Range</Title>
          <DatesSelector
            hoverRange={hoverRange}
            selectedDays={selectedDays}
            handleDayChange={handleDayChange}
            handleDayEnter={handleDayEnter}
            handleDayLeave={handleDayLeave}
            handleWeekClick={handleWeekClick}
            disableFutureWeeksPick
            fromLimit={fromLimit}
            toLimit={toLimit}
          />
        </Section>
      </Grid>
      <Section>
        <Title>Summary</Title>
        {reportType === 'DEPOSIT_REPORT' ? (
          <Card>
            <P>
              Your Deposit Report includes the following in weekly aggregated
              values:
            </P>
            <ListWrapper>
              <IconWrapper>
                <CheckIcon />
                Total Sales
              </IconWrapper>
              <IconWrapper>
                <CheckIcon />
                Tax Details
              </IconWrapper>
              <IconWrapper>
                <CheckIcon />
                Platform Payout
              </IconWrapper>
              <IconWrapper>
                <CheckIcon />
                Superorder Payout
              </IconWrapper>
            </ListWrapper>
            <Button
              type="button"
              onClick={handleRequestReport}
              disabled={isRequestReportLoading}
            >
              create report
            </Button>
          </Card>
        ) : (
          <Card>
            <P>Your Sales Report includes the folowing:</P>
            <ListWrapper>
              <IconWrapper>
                <CheckIcon />
                Total Sales
              </IconWrapper>
              <IconWrapper>
                <CheckIcon />
                Platform Payout
              </IconWrapper>
              <IconWrapper>
                <CheckIcon />
                Tax Details
              </IconWrapper>
              <IconWrapper>
                <CheckIcon />
                Forward Kitchen Payout
              </IconWrapper>
              <IconWrapper>
                <CheckIcon />
                Fees + Marketing
              </IconWrapper>
            </ListWrapper>
            <Button
              type="button"
              onClick={handleRequestReport}
              disabled={isRequestReportLoading}
            >
              create report
            </Button>
          </Card>
        )}
      </Section>
      <Section>
        <Title>Reports History</Title>
        <ReportsTable
          rows={reports}
          isLoading={
            (isFetching || isRequestReportLoading) && !isFetchingNextPage
          }
        />
        {isFetchingNextPage && (
          <LoaderWrapper>
            <Spinner />
          </LoaderWrapper>
        )}
        {hasNextPage && !isFetching && (
          <BottomScrollListener
            triggerOnNoScroll
            onBottom={() => fetchNextPage()}
          />
        )}
      </Section>
    </Container>
  );
};

export default Download;
